import { useFormSchema } from "src/api/hooks/useFormSchema";

/**
 * Custom LabelTemplate to control how labels are rendered
 * This is used when you want more control over just the label rendering
 */
export const CustomLabelTemplate = (props: any) => {
  const { label, required, id } = props;
  const { data: schema } = useFormSchema();

  if (!label) {
    return null;
  }

  const secondaryColor = schema?.theme?.colors?.secondary;
  const errorColor = schema?.theme?.colors?.error;

  return (
    <label
      htmlFor={id}
      className={`text-base font-semibold mb-2 block ${
        !secondaryColor ? "text-Grey7" : ""
      } ${required ? "after:content-['*'] after:ml-1" : ""} ${
        required && !errorColor ? "after:text-PrimaryRed" : ""
      }`}
      style={{
        ...(secondaryColor && { color: secondaryColor }),
        ...(required &&
          errorColor && {
            "--after-color": errorColor,
          }),
      }}
    >
      {label} ---
      {required && errorColor && (
        <style>{`
          label[htmlFor="${id}"]::after {
            color: ${errorColor} !important;
          }
        `}</style>
      )}
    </label>
  );
};
